export default __webpack_public_path__ + "static/media/PHONEPE2.ac53a3be.png";